import { render, staticRenderFns } from "./ConfirmEditAndUnpublish.vue?vue&type=template&id=34b6a58e&scoped=true&"
import script from "./ConfirmEditAndUnpublish.vue?vue&type=script&lang=js&"
export * from "./ConfirmEditAndUnpublish.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEditAndUnpublish.vue?vue&type=style&index=0&id=34b6a58e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6a58e",
  null
  
)

export default component.exports